import { combineEpics } from "redux-observable";
import { of } from "rxjs";
import { produceLoadLoadingLoadedEpic } from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import GatingV2Resource from "@ane/exp-data/lib/resources/GatingV2Resource";
import { TransitionGateStates } from "@ane/exp-data/lib/models";
import { overrideGateActionTypes, resolvingGate, gateResolved } from "./OverrideGate.ducks.js";
import { getAdditionalInfoForGate } from "../../utils/GatingUtils.js";
const OverrideGateEpic = produceLoadLoadingLoadedEpic({
  filterOnType: overrideGateActionTypes.LOAD,
  loadResource: (payload) => {
    const result = {
      target: payload.stepId,
      gateName: payload.gateName,
      state: TransitionGateStates.Override,
      comment: "",
      content: getAdditionalInfoForGate(payload.gateName)
    };
    const { target, gateName, state, comment, content } = result;
    return GatingV2Resource.updateExperimentGate(target, gateName, state, comment, content);
  },
  loadingAction: () => resolvingGate(),
  loadedAction: (result) => {
    return of(gateResolved(getCompletedAsyncWrapperObj(result.result, result.error)));
  }
});
const ResolveSeedfinderGateEpics = combineEpics(OverrideGateEpic);
export {
  ResolveSeedfinderGateEpics as default
};
//# sourceMappingURL=OverrideGate.epics.js.map
